<div>
  <app-filter-product (searchEvent)="search($event)"></app-filter-product>
</div>

<div>
  @if (searchValue.length) {
    <h6 class="odx-title-6" i18n="@@floorplan.header.searchResults">Suchergebnisse</h6>
  }
  @if (filteredResults.length > 0 || !searchValue.length) {
    <div>
      @for (result of filteredResults; track result) {
        <div>
          <hr />
          <app-monitoring-search-item
            [result]="result"
            [canAddToFloorplan]="result.canAddToFloorplan ?? true"
            (addToFloorplan)="addToFloorplan($event)"
            (showGroupDetails)="showGroupDetails($event)"
            (addToBom)="addToBom($event)"
          ></app-monitoring-search-item>
        </div>
      }
    </div>
  } @else {
    <div class="no-products-container">
      <div class="no-products-message" i18n="@@floorplan.productSearch.noResults">Keine Suchergebnisse</div>
      <button
        odxButton
        i18n="@@monitoring.productSearch.usePlaceholder"
        (click)="$event.stopPropagation(); openSelectPlaceholderMenu()"
      >
        Mit einem Platzhalter weiterarbeiten
      </button>
    </div>
  }
</div>
